import React from "react";
import LeadForm from "../forms/LeadForm";
import { Body, SectionHeading } from "./primitives";

/** Landing-page lead capture block. Submissions land in the admin inbox as "Promo lead". */
const FormBlock = ({ block, onCta, slug }) => (
  <section className="container-x py-16 lg:py-24" id="lead-form" data-testid="lp-block-form">
    <div className="grid gap-10 lg:grid-cols-12 lg:gap-14">
      <div className="lg:col-span-5">
        <SectionHeading>{block.heading || "Get in touch"}</SectionHeading>
        <Body className="mt-5">{block.body}</Body>
      </div>
      <div className="border border-primary/40 bg-card p-6 md:p-8 lg:col-span-7">
        <LeadForm
          formType="lead"
          showPhone={block.show_phone !== false}
          showMessage={block.show_message !== false}
          submitLabel={block.cta_label || "Send request"}
          successTitle="Thanks — we got it"
          successBody={block.success_message || "Someone from the studio will be in touch shortly."}
          messagePlaceholder="Tell us about the piece you have in mind."
          extra={{ page_slug: slug || "", block_id: block.id }}
          onSuccess={() => onCta?.(`Lead form: ${block.heading || "Lead form"}`, "#lead-form")}
          testId="lp-lead-form"
        />
      </div>
    </div>
  </section>
);

export default FormBlock;
